import { createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-447d2dbb")

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock("div", {
    class: ["SearchInput", {
      'SearchInput--active': _ctx.isFocus,
    }]
  }, [
    _createVNode("input", {
      class: "SearchInput__control",
      placeholder: _ctx.placeholder,
      maxlength: _ctx.maxlength,
      value: _ctx.keyword,
      ref: "searchInput",
      onFocus: _cache[1] || (_cache[1] = $event => (_ctx.isFocus = true)),
      onBlur: _cache[2] || (_cache[2] = $event => (_ctx.isFocus = false)),
      onInput: _cache[3] || (_cache[3] = $event => (_ctx.$emit('update:keyword', $event.target.value)))
    }, null, 40, ["placeholder", "maxlength", "value"]),
    _createVNode("button", {
      class: "SearchInput__icon-container",
      onClick: _cache[4] || (_cache[4] = _withModifiers((...args) => (_ctx.onClick(...args)), ["stop"]))
    }, [
      _createVNode(_component_Icon, {
        type: _ctx.IconType.IC_18_SEARCH_PRESS,
        size: 24
      }, null, 8, ["type"])
    ])
  ], 2))
})